import r from "../managers/braze-instance.js";
import { logger as N, IndexedDBAdapter as st } from "../../shared-lib/index.js";
import et from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as ot } from "../triggers/triggers-provider-factory.js";
export function openSession() {
  if (!r.rr()) return;
  var i = r.rn();
  if (!i) return;
  i.openSession();
  var t = st.Ls.Fs,
      o = new st(t, N);
  o.cr(t.Ms.jr, function (r, n) {
    var e = n.lastClick,
        s = n.trackingString;
    N.info("Firing push click trigger from ".concat(s, " push click at ").concat(e));

    var c = i.lr(e, s),
        g = function g() {
      ot.m().Ce(et.hr, [s], c);
    };

    i.br(g, g), o.ge(t.Ms.jr, r);
  }), o.Ns(t.Ms.kr, function (r) {
    i.vr(r);
  });
}